var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgConductors = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0H2V5H4V0ZM2 6C0.895447 6 0 6.89543 0 8V10C0 11.1046 0.895447 12 2 12H4C5.10455 12 6 11.1046 6 10H7V12H8V10V8V6H7V8H6C6 6.89543 5.10455 6 4 6H2ZM2 13H4V18H2V13ZM14 0H12V5H14V0ZM12 6C10.8954 6 10 6.89543 10 8V10C10 11.1046 10.8954 12 12 12H14C15.1046 12 16 11.1046 16 10H17V12H18V10V8V6H17V8H16C16 6.89543 15.1046 6 14 6H12ZM12 13H14V18H12V13Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgConductors, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/conductors.958866f0.svg";
export { ForwardRef as ReactComponent };